import AvatarPortalWelcomeVideoPoster from "../../../../../images/posters/avatar/portal/avatar-portal-welcome-video.webp";
import ClientRegistrationPoster from "../../../../../images/posters/avatar/portal/client-registration.webp";
import UpdatingBillingMethodPoster from "../../../../../images/posters/avatar/portal/update-billing.webp";
import AddingClientPoster from "../../../../../images/posters/avatar/portal/adding-client.webp";
import RemovingClientPoster from "../../../../../images/posters/avatar/portal/removing-client.webp";
import EmailAlreadyExistsPoster from "../../../../../images/posters/avatar/portal/email-exists.webp";
import ProviderOversightPoster from "../../../../../images/posters/avatar/portal/provider-oversight.webp";
import AddingTrainerPoster from "../../../../../images/posters/avatar/portal/add-trainer.webp";
import AssigningTrainerPoster from "../../../../../images/posters/avatar/portal/assign-trainer.webp";
import EditingClientMacrosPoster from "../../../../../images/posters/avatar/portal/edit-client-macros.webp";
import EditingCheckInPoster from "../../../../../images/posters/avatar/portal/edit-checkin.webp";
import MonitoringTrackingAdherencePoster from "../../../../../images/posters/avatar/portal/monitoring.webp";
import AnalyzingClientTimelinePoster from "../../../../../images/posters/avatar/portal/analyze.webp";
import ClientsInNeedOfAttentionPoster from "../../../../../images/posters/avatar/portal/attention.webp";
import SetCheckInDaysPoster from "../../../../../images/posters/avatar/portal/edit-checkin-day.webp";
import BillingExplainedPoster from "../../../../../images/posters/avatar/portal/billing-explained.webp";
// import TemplatesPoster from "../../../../../images/posters/avatar/portal/templates.webp";
import MessagingClientsPoster from "../../../../../images/posters/avatar/portal/messaging.webp";
import AddingClientToGroupPoster from "../../../../../images/posters/avatar/portal/add-groups.webp";
import RemovingClientsFromGroupsPoster from "../../../../../images/posters/avatar/portal/remove-from-group.webp";
import MessagingGroupsPoster from "../../../../../images/posters/avatar/portal/message-groups.webp";
import TurnOnMessagingPoster from "../../../../../images/posters/avatar/portal/messaging-toggle.webp";
import TurnOnDailyMacroAdjustmentsPoster from "../../../../../images/posters/avatar/portal/daily-macro-adjustments.webp";
import HighLowDaysPoster from "../../../../../images/posters/avatar/portal/high-low-days.webp";
import TurnOnDailyWeightsPoster from "../../../../../images/posters/avatar/portal/daily-weights-toggle.webp";
import CampaignsPoster from "../../../../../images/posters/avatar/portal/campaigns.webp";
import VacationModePoster from "../../../../../images/posters/avatar/portal/vacation.webp";
import ChangingGoalPoster from "../../../../../images/posters/avatar/portal/change-goal.webp";
import TrainerNotesPoster from "../../../../../images/posters/avatar/portal/trainer-notes.webp";
import AdminVsNonAdminPoster from "../../../../../images/posters/avatar/portal/admin.webp";
import CheckInFormsPoster from "../../../../../images/posters/avatar/portal/check-in-forms.webp";
import PausePracticeModesPoster from "../../../../../images/posters/avatar/portal/pause-practice-modes.webp";
import ClientPermissionsPoster from "../../../../../images/posters/avatar/portal/client-permissions.webp";
import MealPlanningPoster from "../../../../../images/posters/avatar/portal/meal-planning.webp";
import SetUpHighLowDaysPoster from "../../../../../images/posters/avatar/portal/set-up-high-low-days.webp";

const avatarPortalVideos = [
  {
    "title": "Portal Welcome Video",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/Avatar+Nutrition+Portal+Welcome+2026.mp4",
    "thumbnail": AvatarPortalWelcomeVideoPoster,
    "length": "3:11"
  },
  {
    "title": "Client Registration Flow",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/User+Registration.mp4",
    "thumbnail": ClientRegistrationPoster,
    "length": "4:55"
  },
  {
    "title": "Update Billing Method",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/Updating Billing Method.mp4",
    "thumbnail": UpdatingBillingMethodPoster,
    "length": "0:20"
  },
  {
    "title": "Adding a Client",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/may-2026/Adding+a+Client.mp4",
    "thumbnail": AddingClientPoster,
    "length": "0:46"
  },
  {
    "title": "Removing a Client",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/Removing+a+Client.mp4",
    "thumbnail": RemovingClientPoster,
    "length": "0:27"
  },
  {
    "title": "Email Already Exists Error Fix",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/Email+Already+Exists.mp4",
    "thumbnail": EmailAlreadyExistsPoster,
    "length": "0:49"
  },
  {
    "title": "Provider Oversight and Permissions",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/Provider+Oversight.mp4",
    "thumbnail": ProviderOversightPoster,
    "length": "0:16"
  },
  {
    "title": "Adding a Trainer",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/may-2026/Adding+a+Trainer.mp4",
    "thumbnail": AddingTrainerPoster,
    "length": "0:39"
  },
  {
    "title": "Assigning a Client to a Trainer",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/may-2026/Assigning+Clients+to+a+Trainer.mp4",
    "thumbnail": AssigningTrainerPoster,
    "length": "0:39"
  },
  {
    "title": "Editing Client Macros",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/may-2026/Editing+Client+Macros.mp4",
    "thumbnail": EditingClientMacrosPoster,
    "length": "1:00"
  },
  {
    "title": "Editing a Check In",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/Editing+a+Check-In.mp4",
    "thumbnail": EditingCheckInPoster,
    "length": "0:52"
  },
  {
    "title": "Monitoring and Tracking Adherence",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/may-2026/Monitoring+and+Tracking+Adherence.mp4",
    "thumbnail": MonitoringTrackingAdherencePoster,
    "length": "1:47"
  },
  {
    "title": "Analyzing a Client Timeline",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/may-2026/Analyzing+a+Client+Timeline.mp4",
    "thumbnail": AnalyzingClientTimelinePoster,
    "length": "1:56"
  },
  {
    "title": "Clients in Need of Attention",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/may-2026/Clients+in+Need+of+Attention.mp4",
    "thumbnail": ClientsInNeedOfAttentionPoster,
    "length": "1:01"
  },
  {
    "title": "Change Client Check-In Day",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/may-2026/Change+Client+Check-in+Day.mp4",
    "thumbnail": SetCheckInDaysPoster,
    "length": "1:34"
  },
  {
    "title": "Billing Explained",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/may-2026/Billing+Explained.mp4",
    "thumbnail": BillingExplainedPoster,
    "length": "1:38"
  },
  // {
  //   "title": "Templates",
  //   "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/Templates.mp4",
  //   "thumbnail": TemplatesPoster,
  //   "length": "1:07"
  // },
  {
    "title": "Messaging Clients",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/may-2026/Messaging+Clients.mp4",
    "thumbnail": MessagingClientsPoster,
    "length": "0:51"
  },
  {
    "title": "Adding Clients to a Group",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/Adding+Client+to+Group.mp4",
    "thumbnail": AddingClientToGroupPoster,
    "length": "0:13"
  },
  {
    "title": "Remove Client from Group",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/Removing+Clients+from+Groups.mp4",
    "thumbnail": RemovingClientsFromGroupsPoster,
    "length": "0:33"
  },
  {
    "title": "Messaging Groups",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/may-2026/Messaging+Groups.mp4",
    "thumbnail": MessagingGroupsPoster,
    "length": "1:11"
  },
  {
    "title": "Turn on Messaging",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/may-2026/Turn+on+Messaging.mp4",
    "thumbnail": TurnOnMessagingPoster,
    "length": "0:11"
  },
  {
    "title": "Turn on Daily Macro Adjustments",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/Turn+on+Daily+Macro+Adjustments.mp4",
    "thumbnail": TurnOnDailyMacroAdjustmentsPoster,
    "length": "1:07"
  },
  // {
  //   "title": "Setting up High/Low Days",
  //   "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/High+Low+Days.mp4",
  //   "thumbnail": HighLowDaysPoster,
  //   "length": "1:42"
  // },
  {
    "title": "Turn on Daily Weights",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/Turn+on+Daily+Weights.mp4",
    "thumbnail": TurnOnDailyWeightsPoster,
    "length": "0:54"
  },
  {
    "title": "Campaigns",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/may-2026/Campaigns.mp4",
    "thumbnail": CampaignsPoster,
    "length": "1:21"
  },
  // {
  //   "title": "Vacation Mode",
  //   "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/Vacation+Mode.mp4",
  //   "thumbnail": VacationModePoster,
  //   "length": "0:23"
  // },
  {
    "title": "Change Client Goals",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/may-2026/Change+Client+Goals.mp4",
    "thumbnail": ChangingGoalPoster,
    "length": "0:20"
  },
  {
    "title": "Adding Trainer Notes",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/may-2026/Adding+Trainer+Notes.mp4",
    "thumbnail": TrainerNotesPoster,
    "length": "0:25"
  },
  {
    "title": "Admin vs Non-Admin Trainers",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/may-2026/Admin+vs+Non-Admin.mp4",
    "thumbnail": AdminVsNonAdminPoster,
    "length": "0:42"
  },
  {
    "title": "Check-in Forms",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/may-2026/Check+In+Forms.mp4",
    "thumbnail": CheckInFormsPoster,
    "length": "7:50"
  },
  {
    "title": "Practice and Pause Modes",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/may-2026/Practice+Mode+and+Pause+your+Goal.mp4",
    "thumbnail": PausePracticeModesPoster,
    "length": "2:43"
  },
  {
    "title": "Change Client Permissions",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/may-2026/Changing+Client+Permissions.mp4",
    "thumbnail": ClientPermissionsPoster,
    "length": "0:15"
  },
  {
    "title": "Meal Planning",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/may-2026/Meal+Planning.mp4",
    "thumbnail": MealPlanningPoster,
    "length": "1:32"
  },
  {
    "title": "Set Up High/Low Days",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/portal/may-2026/Set+up+High+Low+Days.mp4",
    "thumbnail": SetUpHighLowDaysPoster,
    "length": "0:42"
  }
];

export default avatarPortalVideos; 